<template>

    <v-row >
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="editUser">
          <v-icon left>mdi-pencil</v-icon>{{$t('Settings.edit')}}
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="changePassword">
          <v-icon left>settings</v-icon>{{$t('Settings.password')}}
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="deleteUser">
          <v-icon left>delete</v-icon>{{$t('Settings.delete')}}
        </v-btn>
      </v-col>
    </v-row>

</template>

<script>

export default {

  data: () => ({

  }),
  props: {
    source: String
  },
  methods: {
    editUser: function() {
      this.$emit('edituser');
    },
    changePassword: function() {
      this.$emit('changePassword');
    },
    deleteUser: function() {
      console.log("delete");
    }
  }
};
</script>


